export const TOP_BAR_TAB_ITEMS = [
	{
		title: 'shop',
		icon: 'mdi-view-comfy',
		to: '/store',
		privileges: ['shop-get']
	},
	{
		title: 'finance',
		icon: 'mdi-bank',
		to: '/finance',
		privileges: ['finance-get']
	},
	{
		title: 'admin',
		icon: 'mdi-account-cog-outline',
		to: '/admin',
		privileges: ['admin-get'],
	}
];

export const SIDEBAR_ADMIN_TAB_ITEMS = [
	{
		title: 'pages.pages',
		icon: 'mdi-file-cog',
		active: true,
		items: [
			{
				title: 'pages.home',
				link: '/admin/pages/home',
				icon: 'mdi-numeric-1',
				privileges: ['admin-get']
			},
			// {
			// 	title: 'pages.aboutUs',
			// 	link: '/admin/pages/about-us',
			// 	icon: 'mdi-numeric-2',
			// 	privileges: ['admin-get']
			// },
			// {
			// 	title: 'pages.whyWe',
			// 	link: '/admin/pages/why-we',
			// 	icon: 'mdi-numeric-3',
			// 	privileges: ['admin-get']
			// },
			// {
			// 	title: 'pages.services',
			// 	link: '/admin/pages/services',
			// 	icon: 'mdi-numeric-4',
			// 	privileges: ['admin-get']
			// },
			{
				title: 'pages.contacts',
				link: '/admin/pages/contacts',
				icon: 'mdi-numeric-2',
				privileges: ['admin-get']
			},
			{
				title: 'pages.socialLinks',
				link: '/admin/pages/social-links',
				icon: 'mdi-numeric-3',
				privileges: ['admin-get']
			},
			// {
			// 	title: 'pages.portfolio',
			// 	link: '/admin/pages/projects',
			// 	icon: 'mdi-numeric-7',
			// 	privileges: ['admin-get']
			// },
			// {
			// 	title: 'pages.skills',
			// 	link: '/admin/pages/skills',
			// 	icon: 'mdi-numeric-8',
			// 	privileges: ['admin-get']
			// },
			// {
			// 	title: 'pages.testimonials',
			// 	link: '/admin/pages/testimonials',
			// 	icon: 'mdi-numeric-9',
			// 	privileges: ['admin-get']
			// },
			// {
			// 	title: 'pages.funFacts',
			// 	link: '/admin/pages/fun-facts',
			// 	icon: 'mdi-numeric-1',
			// 	extraIcon: 'mdi-numeric-0',
			// 	privileges: ['admin-get']
			// },
			{
				title: 'pages.faq',
				link: '/admin/pages/faq',
				icon: 'mdi-numeric-4',
				privileges: ['admin-get']
			},
			// {
			// 	title: 'pages.team',
			// 	link: '/admin/pages/staff',
			// 	icon: 'mdi-numeric-1',
			// 	extraIcon: 'mdi-numeric-2',
			// 	privileges: ['admin-get']
			// },
			{
				title: 'pages.privacyPolicy',
				link: '/admin/pages/privacy-policy',
				icon: 'mdi-numeric-5',
				privileges: ['admin-get']
			},
			{
				title: 'pages.publicOffer',
				link: '/admin/pages/public-offer',
				icon: 'mdi-numeric-6',
				privileges: ['admin-get']
			}
		]
	},
	{
		title: 'pages.userManagement',
		icon: 'mdi-account-cog',
		active: true,
		items: [
			{
				title: 'pages.userGroups',
				link: '/admin/user-management/user-groups',
				icon: 'mdi-shield-account',
				privileges: ['admin-get']
			},
			{
				title: 'pages.users',
				link: '/admin/user-management/users',
				icon: 'mdi-account-group',
				privileges: ['admin-get']
			}
		]
	}
];

export const SIDEBAR_SHOP_TAB_ITEMS = [
	{
		title: 'shop.orders',
		link: '/store/orders',
		icon: 'mdi-cart',
		privileges: ['shop-get']
	},
	{
		title: 'shop.onlineShop',
		link: '/store/products',
		icon: 'mdi-store',
		privileges: ['shop-get']
	},
	{
		title: 'shop.arrivals',
		link: '/store/arrivals',
		icon: 'mdi-warehouse',
		privileges: ['shop-get']
	},
	{
		title: 'shop.miniCatalog',
		link: '/store/mini-catalog',
		icon: 'mdi-format-list-text',
		privileges: ['shop-get']
	},
	{
		title: 'shop.clients',
		link: '/store/clients',
		icon: 'mdi-account-group',
		privileges: ['shop-get']
	},
	{
		title: 'shop.banners',
		link: '/store/banners',
		icon: 'mdi-image-area',
		privileges: ['shop-get']
	},
	{
		title: 'shop.blog',
		link: '/store/blogs',
		icon: 'mdi-post',
		privileges: ['shop-get']
	},
	{
		title: 'shop.productReviews',
		link: '/store/product-reviews',
		icon: 'mdi-comment-processing',
		privileges: ['shop-get']
	},
	{
		title: 'shop.requests',
		icon: 'mdi-comment-alert',
		active: true,
		items: [
			{
				title: 'shop.shop',
				link: '/store/requests/store',
				icon: 'mdi-store',
				privileges: ['shop-get']
			}
		]
	},
	{
		title: 'shop.settings',
		icon: 'mdi-cog',
		active: true,
		items: [
			{
				title: 'shop.colors',
				link: '/store/settings/colors',
				icon: 'mdi-palette',
				privileges: ['shop-get']
			},
			{
				title: 'shop.coupons',
				link: '/store/settings/coupons',
				icon: 'mdi-ticket-percent',
				privileges: ['shop-get']
			},
			{
				title: 'shop.branches',
				link: '/store/settings/branches',
				icon: 'mdi-home',
				privileges: ['shop-get']
			},
			{
				title: 'shop.productsCategories',
				link: '/store/settings/product-categories',
				icon: 'mdi-archive-cog',
				privileges: ['shop-get']
			},
			{
				title: 'shop.productsSubcategories',
				link: '/store/settings/product-subcategories',
				icon: 'mdi-archive-cog-outline',
				privileges: ['shop-get']
			},
			{
				title: 'shop.productsBrands',
				link: '/store/settings/product-brands',
				icon: 'mdi-archive-star',
				privileges: ['shop-get']
			}
		]
	}
];

export const SIDEBAR_FINANCE_TAB_ITEMS = [
	{
		title: 'finance.arrivalProductMarkup',
		link: '/finance/arrival-product-markup',
		icon: 'mdi-cash-plus',
		privileges: ['finance-get']
	},
	{
		title: 'finance.rates',
		icon: 'mdi-finance',
		active: true,
		items: [
			{
				title: 'finance.exchangeRates',
				link: '/finance/rates/exchange-rates',
				icon: 'mdi-cash-100',
				privileges: ['finance-get']
			},
			{
				title: 'finance.coinRates',
				link: '/finance/rates/coin-rates',
				icon: 'mdi-bitcoin',
				privileges: ['finance-get']
			}
		]
	},
	{
		title: 'finance.transactions',
		icon: 'mdi-swap-horizontal-bold',
		active: true,
		items: [
			{
				title: 'finance.purchases',
				link: '/finance/transactions/purchases',
				icon: 'mdi-credit-card',
				privileges: ['finance-get']
			},
			{
				title: 'finance.coins',
				link: '/finance/transactions/coins',
				icon: 'mdi-hand-coin',
				privileges: ['finance-get']
			}
		]
	},
	{
		title: 'finance.policies',
		icon: 'mdi-file-cog',
		active: true,
		items: [
			{
				title: 'finance.pricePolicy',
				link: '/finance/policies/price-policy',
				icon: 'mdi-cart-percent',
				privileges: ['finance-get']
			},
			// {
			// 	title: 'finance.priceCoinsPolicy',
			// 	link: '/finance/policies/price-coins-policy',
			// 	icon: 'mdi-percent-circle',
			// 	privileges: ['finance-get']
			// },
			{
				title: 'finance.referralBonusPolicy',
				link: '/finance/policies/referral-bonus-policy',
				icon: 'mdi-gift',
				privileges: ['finance-get']
			},
			{
				title: 'finance.clientLevelRules',
				link: '/finance/policies/client-level-rules',
				icon: 'mdi-podium-silver',
				privileges: ['finance-get']
			},
		]
	},
	{
		title: 'finance.currencies',
		link: '/finance/currency',
		icon: 'mdi-cash-multiple',
		privileges: ['finance-get']
	},
];
